import React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import * as Styled from "./HorizontalNav.styled";

interface Props {
  testId?: string;
}

export const Nav: React.FC<React.PropsWithChildren<Props>> = props => {
  return (
    <TestWrapper testId={props.testId}>
      <Styled.Nav>
        <Styled.List>{props.children}</Styled.List>
      </Styled.Nav>
    </TestWrapper>
  );
};
